import SButton from "components/Common/Button"
import { uploadFabricAPI } from "helpers/fabric_resource"
import React, { useState } from "react"
import { toast } from "react-toastify"
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap"

function UploadFile({ isModal, setIsModal, refetch }) {
  const toggle = () => setIsModal(!isModal)
  const [file, setFile] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false)

  const onSubmit = () => {
    setIsProcessing(true)
    let formData = new FormData()
    formData.append("file", file)
    uploadFabricAPI(formData)
      .then(res => {
        setIsProcessing(false)
        toggle()
        refetch()
      })
      .catch(err => {
        if (err.response.status === 403) {
          toast.error(
            "ファイルアップロードに失敗しました。ファイルをもう一度ご確認してください。"
          )
        } else if (err.response.status === 400) {
          toast.error(err.response?.data?.message)
        }
        setIsProcessing(false)
      })
  }

  return (
    <Modal isOpen={isModal} toggle={toggle} centered className="modal-lg">
      <ModalHeader toggle={toggle}>生地マスター一括追加編集 </ModalHeader>
      <ModalBody>
        <input
          type="file"
          onChange={e => setFile(e.target.files[0])}
          accept=".xlsx"
          className="form-control"
        />
      </ModalBody>
      <ModalFooter>
        <SButton
          disabled={!file || isProcessing}
          onClick={onSubmit}
          className="px-5"
          color="primary"
        >
          {isProcessing ? <Spinner size="sm" color="light" /> : "保存"}
        </SButton>
      </ModalFooter>
    </Modal>
  )
}

export default UploadFile
